module.exports = __webpack_public_path__ + "media/images/application/template/logo-c59e5cc15ff73df21f7fb1c15d0a393d.svg";